import { render, staticRenderFns } from "./guest_nogoods.vue?vue&type=template&id=60c7adb0"
import script from "./guest_nogoods.vue?vue&type=script&lang=js"
export * from "./guest_nogoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports